import axios from "axios";

// Priority order for backend URL:
// 1. REACT_APP_BACKEND_URL env var (set in .env.production or Vercel/Netlify dashboard)
// 2. Localhost fallback for local development
const BACKEND_URL = process.env.REACT_APP_BACKEND_URL || "http://localhost:8000";

export const API = `${BACKEND_URL}/api`;

export const api = axios.create({ baseURL: API });

api.interceptors.request.use((config) => {
  const token = localStorage.getItem("opplio_token");
  if (token) config.headers.Authorization = `Bearer ${token}`;
  return config;
});

api.interceptors.response.use(
  (r) => r,
  (err) => {
    if (err?.response?.status === 401) {
      const currentPath = window.location.pathname;
      if (!["/auth", "/"].includes(currentPath)) {
        localStorage.removeItem("opplio_token");
        localStorage.removeItem("opplio_user");
        window.location.href = "/auth";
      }
    }
    const apiError = err?.response?.data?.error;
    if (apiError) {
      err.message = apiError;
    }
    return Promise.reject(err);
  }
);
